export const ANCHOR_HEADER = ['H2', 'H3'];
